import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { memo } from 'react';
import strings from '../../../Globalization';
import DigitalGraph from '../../../components/common/DigitalGraph';
import { useCycleInfo } from '../../../contexts/CycleInfo/Context';

const PreWash = ({ property, propertyName }) => {
	const { data: cycle } = useCycleInfo();
	const data = cycle.ChartDetail[property];

	return (
		<Grid container>
			<Grid size={12}>
				<Card>
					<CardContent sx={{ padding: 4 }}>
						<Grid container>
							<Grid size={{xs: 12, md: 4}}  paddingTop={2}>
								<Box
									display={'flex'}
									sx={{
										borderTop: (theme) => `1px solid ${theme.palette.divider}`,
										borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
										padding: (theme) => theme.spacing(1)
									}}
								>
									<Typography variant="subtitle2" flex={1}>
										{strings[propertyName]}{' '}
										{data.ThermalRinseA0 === 'None' ? '' : '- ' + data.ThermalRinseA0}
									</Typography>
									<TimerOutlinedIcon />
								</Box>

								<Box>
									<Typography textAlign={'center'}>
										{strings.FillingPortPure} {data.PreWash.WaterPort}
									</Typography>
									<DigitalGraph title={strings.SetTime} value={data.PreWash.SetTime} />
									<DigitalGraph title={strings.ActualTime} value={data.PreWash.ActualTime} />
								</Box>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default memo(PreWash);
